module.exports = __webpack_public_path__ + "img/elec3_hover.35445818.png";